import React from 'react';
import { Button, ButtonGroup, Form } from 'react-bootstrap';
import './AdjustmentInput.css';

/**
 * 조정금 입력 UI. 상태는 useAdjustment 훅이 들고 이 컴포넌트는 그리기만 한다.
 *
 * 모바일에서 '-' 입력이 까다로워 부호 대신 추가/할인 토글을 쓴다 — 입력칸은 항상 양수.
 *
 * 사유 칸은 조정금이 0이 아닐 때만 나타난다. 조정은 드물게 쓰는 기능이라
 * 항상 띄우면 대부분의 접수에서 빈 칸만 하나 늘어난다. 세 폼(현장/모달/워크보드)이
 * 같은 조건을 쓰므로 "같은 상황에서 같은 칸이 보인다"는 일관성은 유지된다.
 *
 * 워크보드는 wf-input 클래스를 쓰므로 inputClassName 으로 받는다.
 */
const AdjustmentInput = ({
    adjustment,
    size = 'sm',
    inputClassName = 'border-0 shadow-sm',
    inputStyle,
    placeholder = '조정 금액',
    showReason = true,
}) => {
    const { mode, setMode, amount, setAmount, reason, setReason } = adjustment;
    const hasAmount = (parseFloat(amount) || 0) !== 0;

    return (
        <div className="adj-input">
            <div className="adj-row">
                <ButtonGroup size={size}>
                    <Button
                        variant={mode === 'add' ? 'primary' : 'outline-secondary'}
                        onClick={() => setMode('add')}
                        type="button"
                    >+ 추가</Button>
                    <Button
                        variant={mode === 'discount' ? 'danger' : 'outline-secondary'}
                        onClick={() => setMode('discount')}
                        type="button"
                    >− 할인</Button>
                </ButtonGroup>
                <Form.Control
                    type="number"
                    inputMode="numeric"
                    min="0"
                    size={size}
                    placeholder={placeholder}
                    value={amount}
                    onChange={(e) => setAmount(e.target.value.replace(/-/g, ''))}
                    className={inputClassName}
                    style={inputStyle}
                />
            </div>
            {showReason && hasAmount && (
                <Form.Control
                    type="text"
                    size={size}
                    placeholder={mode === 'discount' ? '할인 사유 (선택)' : '추가 사유 (선택)'}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className={inputClassName}
                />
            )}
        </div>
    );
};

export default AdjustmentInput;
